// Swiper initializer for Case Study – Slider (ESM, v10/11)
import Swiper from 'swiper';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';
// Load Swiper CSS once in your main entry if you prefer:
// import 'swiper/css'; import 'swiper/css/pagination'; import 'swiper/css/navigation';

export function initCaseStudySliders(root = document) {
    const swipers = root.querySelectorAll('.js-case-swiper');
    swipers.forEach((el) => {
        if (el.__dpage_inited) return;
        el.__dpage_inited = true;

        // Find external controls scoped to this slider wrapper
        const wrapper = el.closest('.dpage-case-study-slider') || el.parentElement;
        const paginationEl = wrapper.querySelector('.swiper-pagination');
        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');

        // Create Swiper
        new Swiper(".dpage-cs-swiper", {
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            coverflowEffect: {
                rotate: 50,
                depth: 200,
                // stretch: 100,
                slideShadows: true,
            },
            pagination: { el: paginationEl, clickable: true },
            navigation: { nextEl, prevEl },
            modules: [EffectCoverflow, Pagination, Navigation],
        });
    });
}
